<template>
  <div id="error-page">
    <header id="header">
      <span class="flex-item-logo">
        <router-link class="logo" to="/">
          <img class="logo-img" src="@/assets/img/logo.png" />
        </router-link>
      </span>
    </header>
    <div class="body">
      <div class="box">
        <div class="text">
          <h2>{{ $t("annualReport2023Page.description") }}</h2>
        </div>
        <div class="image">
          <div class="button-wrapper">
            <a
              href="https://apps.apple.com/jp/app/nola-%E5%B0%8F%E8%AA%AC%E3%82%92%E6%9B%B8%E3%81%8F%E4%BA%BA%E3%81%AE%E3%81%9F%E3%82%81%E3%81%AE%E5%9F%B7%E7%AD%86%E3%82%A8%E3%83%87%E3%82%A3%E3%82%BF%E3%83%84%E3%83%BC%E3%83%AB/id1468307521"
              target="_blank"
            >
              <img src="@/assets/img/static/app_store_badge.svg" alt="app store" />
            </a>
          </div>
          <div class="button-wrapper">
            <a href="https://play.google.com/store/apps/details?id=com.nola.app&hl=ja&gl=US" target="_blank">
              <img src="@/assets/img/static/google_play_badge.png" alt="google play" />
            </a>
          </div>
        </div>
        <router-link to="/">
          <button>{{ $t("annualReport2023Page.backToTop") }}</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
});
</script>

<style lang="scss" scoped>
$header-border: 3px;

#header {
  display: flex;
  position: sticky;
  align-items: center;
  background-color: var(--color-surface-subtle);
  border-bottom: var(--color-border) $header-border solid;
  height: $header-height;
  line-height: 1rem;
  box-sizing: border-box;
  left: 0;
  right: 0;
  top: 0;
  padding: 30px 15px;
  z-index: 20;

  .flex-item-logo {
    flex-grow: 1;

    .logo {
      text-align: center;
      display: block;
      padding: 15px;

      .logo-img {
        height: 42px;

        @include mq(sp) {
          height: 30px;
        }
      }
    }
  }
}

#error-page {
  height: 100vh;
  width: 100vw;

  .body {
    box-sizing: border-box;
    height: calc(100vh - #{$header-height});
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
    background-color: var(--color-background-normal);

    .box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: var(--color-surface-subtle);
      border-radius: var(--radius-lg);
      padding: 50px 100px;
      max-width: 50%;

      @include mq(sp) {
        max-width: calc(100vw * 0.8);
        padding: 30px 15px;
      }

      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h2 {
          margin: 0;
          color: var(--color-text-normal);

          @include mq(sp) {
            font-size: var(--font-size-lg);
          }
        }

        span {
          font-size: var(--font-size-lg);
          color: var(--color-text-low);
        }
      }

      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
      }

      .button-wrapper {
        width: 25%;
        padding: 20px;
        box-sizing: border-box;
      }

      .image a {
        display: block;
      }

      .image img {
        width: 100%;
        height: auto;
        object-fit: contain;
      }

      @include mq(sp) {
        .image {
          gap: 0px;
        }
        .button-wrapper {
          width: 100%;
        }
      }

      button {
        padding: 15px 30px;
        border-radius: var(--radius-rounded);
        border: none;
        background-color: var(--color-primary);
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-bold);
        color: var(--color-text-on-fixed-bg);
        cursor: pointer;
      }
    }
  }
}
</style>
